// Haal de benodigde functionaliteiten op van het Apollo Client-pakket
import { gql, useQuery } from '@apollo/client';
import { useRef, useEffect } from 'react';
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const GET_ABOUT = gql`
    query MyQuery {
        projects {
            id
            icon {
                url
            }
            picture {
                url
            }
            linkTo
            languages
            title
            productiedatum
            description
        }
    }
`;

export default function Projects() {
    const containerRef = useRef(null);
    const { loading, error, data } = useQuery(GET_ABOUT);

    useGSAP(
        () => {
            if (!loading && data && containerRef.current) {
                let sections = gsap.utils.toArray(".panel");
                let container = containerRef.current;

                let scrollTween = gsap.to(sections, {
                    xPercent: -100 * (sections.length - 1),
                    ease: "none",
                    scrollTrigger: {
                        trigger: container,
                        pin: true,
                        scrub: 0.1,
                        end: () => "+=" + (container.scrollWidth - window.innerWidth) * 1.5
                    }
                });

                // Animeer fade en scale voor elk panel (behalve het eerste en laatste)
                sections.forEach((panel, index) => {
                    if (index > 0 && index < sections.length) {
                        gsap.fromTo(sections[index - 1], 
                            {
                                opacity: 1,
                                scale: 1
                            },
                            {
                                opacity: 0,
                                scale: 0.7,
                                scrollTrigger: {
                                    trigger: panel,
                                    containerAnimation: scrollTween,
                                    start: "left 90%",
                                    end: "left 10%",
                                    scrub: 0.1,
                                }
                            }
                        );
                    }
                });
            }
        },
        [loading, data]
    );

    useEffect(() => {
        const demoButtons = document.querySelectorAll("#demo");
        
        demoButtons.forEach((demo) => {
            const rect = demo.querySelector("rect");
            const text = demo.querySelector("text");
            
            if (rect && text) {
                const tl = gsap.timeline({ paused: true });
                
                tl.to(rect, {
                    attr: { width: 160 },
                    fill: "#915eff",
                    opacity: 1,
                    duration: 0.4,
                    ease: "elastic.out(1, 0.5)"
                }, 0);
                
                tl.to(text, {
                    fill: "#fff",
                    duration: 0.2
                }, 0);
                
                demo.addEventListener("mouseenter", () => tl.play());
                demo.addEventListener("mouseleave", () => tl.reverse());
            }
        });
    }, [data]);


    // Controleer of de gegevens nog steeds aan het laden zijn
    if (loading) {
        return <p>Loading...</p>;
    }
    // Check voor errors
    if (error) {
        return <p>Error: {error.message}</p>;
    }

    return (
        <section ref={containerRef} className='container-hor'>
            {data.projects.map((project) => (
                <li
                    className='project panel list-none w-screen h-screen'
                    key={project.id}
                >
                    {/* Use an anchor tag with the slug as the external link */}
                    <div
                        className='col-fade w-full h-full flex items-center justify-center relative'
                    >
                        <div className='w-[60%] relative z-20 pl-32 pr-16'>
                            <p className=''>{project.languages}</p>
                            <h3 className='text-[3rem] w-[90%] mx-auto md:w-full md:text-[3rem] font-bold mt-3 mb-3'>{project.title}</h3>
                            <p className=''>{project.productiedatum}</p>
                            <p className='mt-8 font-light'>{project.description}</p>
                            <a
                                className=''
                                href={`${project.linkTo}`} // Replace with the desired external URL format
                                target="_blank" // Opens the link in a new tab
                                rel="noopener noreferrer" // Best practice for security
                            >
                                <svg id="demo" xmlns="http://www.w3.org/2000/svg" width="220" height="60" viewBox="0 0 220 60">
                                    <rect x="0" y="0" width="60" height="60" rx="30" ry="30" fill="#915eff" opacity="0.4" /> 
                                    <text transform="translate(80 38)" textAnchor="middle" fontSize="20" fill="#fff">READ MORE</text>
                                </svg>
                            </a>
                        </div>
                        <div className='w-[40%] h-full p-1'>
                            <div className='w-full h-full'>
                                <img className='w-full h-full object-contain' width={300} height={100} src={project.picture.url} alt={project.title} />
                            </div>
                        </div>
                    </div>
                </li>
            ))}
        </section>
    );
    
}
